import { Flex, Text } from '../../../Components'
import nora from '../nora.png'

export const ChatContainer = ({ children }) => (
  <Flex
    jb
    js
    style={{
      width: '50%',
      height: 'calc(100vh - 155px)',
      overflow: 'hidden',
      borderRadius: 'var(--radius-lg)',
      border: '1px solid var(--border)',
      background: 'var(--surface)',
      boxShadow: 'var(--shadow-lg)'
    }}
  >
    {children}
  </Flex>
)

export const ChatHeader = () => (
  <Flex
    style={{
      background: 'var(--surface-2)',
      borderBottom: '1px solid var(--border)',
      borderTopLeftRadius: 'var(--radius-lg)',
      borderTopRightRadius: 'var(--radius-lg)',
      height: 80,
      padding: 20
    }}
    row
    fw
    as
    js
  >
    <img src={nora} style={{ borderRadius: '50%', maxWidth: '100%', maxHeight: '100%' }} />
    <Flex style={{ marginLeft: 16 }}>
      <Text value="Nora" bold size={24} style={{ color: 'var(--primary)' }} />
    </Flex>
  </Flex>
)
